import { Avatar, Box, Button, Grid, LinearProgress, Typography } from '@mui/material'
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid'
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { AiOutlinePrinter } from 'react-icons/ai';
import { FiRefreshCcw } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { getReportData } from '../../apis/adminIndex'
import { Colors } from '../../constants/colors';
import { commaSeparated } from '../../constants/GlobalConstants';
import UserPDF from './UserPDF';
import logo from "../../assets/images/kmLogo.png";

const ViewReport = () => {
    const { state } = useLocation();
    console.log("🚀 ~ ViewReport ~ state:", state)
    const [reportData, setReportData] = useState()
    const [loading, setLoading] = useState(false)
    const [pdfReport, setPdfReport] = useState()

    const componentRef = useRef();

    const [cityName, setCityName] = useState('')
    const [machineTime] = useState(moment().format("Do MMMM hh:mma"));

    useEffect(() => {
        handleReportData()
        handleCityName()
    }, [])

    const handleCityName = async () => {
        // Abort the lookup if it stalls, so the report never waits on it forever
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
            const res = await fetch('https://ipwho.is/', { signal: controller.signal })
            const data = await res.json()
            console.log("🚀 ~ city lookup:", data)
            if (data?.success && data?.city) {
                setCityName(data.city)
                return
            }
        } catch (error) {
            console.log("🚀 ~ city lookup error:", error)
        } finally {
            clearTimeout(timer)
        }
        // Last resort only: the timezone is region-wide (Asia/Karachi covers all of
        // Pakistan), so this is a country-level guess, not the real city.
        setCityName(Intl.DateTimeFormat().resolvedOptions().timeZone.split('/').pop().replace(/_/g, ' '))
    }

    const handleReportData = async () => {
        setLoading(true)
        try {
            const res = await getReportData(state?.date)
            console.log("🚀 ~ res:", res)
            setPdfReport(res.data)
            setReportData(res?.data?.map((item) => {
            let group = "";
                if (item.bids[0]?.bidGroup) {
                group = "Yes";
                } else {
                group = "No";
                }
                return {
                    id: item._id,
                    auctionDate: moment(item.AUCTION_DATE).format("Do MMMM hh:mma"),
                    auction: item.AUCTION,
                    lot: item.LOT,
                    maker: item.MARKA_NAME,
                    name: item.bids[0].userId.FirstName + ' ' + item.bids[0].userId.LastName,
                    model: item.MODEL_NAME,
                    modelName: item.MARKA_NAME,
                    year: item.YEAR,
                    bidAmount: commaSeparated(item.bids[0].amount),
                    group:group,
                    status: item.bids[0].status
                }
            })
            )

            setLoading(false)
        } catch (error) {
            console.log("🚀 ~ error:", error)
            setLoading(false)
        }
    }

    // Wait for the city lookup too, otherwise the auto-print can fire first and
    // the printed report goes out with a blank city.
    useEffect(() => {
        if (reportData && cityName) {
            handlePrint();
        }
    }, [reportData, cityName]);


    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <FiRefreshCcw style={{ fontSize: "20px", cursor: "pointer", paddingRight: "15px" }}
                    onClick={() => { }}
                />
                <GridToolbarQuickFilter />
            </GridToolbarContainer>
        );
    }

    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            width: 150,
            editable: false,
            sortable: false,
            valueGetter: (params) =>
                `${params.row.name}`,
        },
       
        {
            field: 'lot',
            headerName: 'Lot No',
            width: 80,
            editable: false,
            sortable: false,
            valueGetter: (params) =>
                `${params.row.lot}`,
        },
        {
            field: 'modelName',
            headerName: 'Maker',
            width: 180,
            editable: false,
            sortable: false,
             renderCell: ({ row }) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3, py: '4px' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{row.modelName}</Typography>
                    <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>{row.model}</Typography>
                </Box>
            ),
           
        },
        
        {
            field: 'year',
            headerName: 'Year',
            width: 70,
            editable: false,
            sortable: false,
            valueGetter: (params) =>
                `${params.row.year}`,
        },
        {
            field: 'bidAmount',
            headerName: 'Bid',
            width: 100,
            editable: false,
            sortable: false,
            valueGetter: (params) =>
                `${params.row.bidAmount}`,
        },
        {
            field: 'cityDateTime',
            headerName: 'City / Date & Time',
            width: 200,
            editable: false,
            sortable: false,
            renderCell: ({ row }) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3, py: '4px' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{row.auction}</Typography>
                    <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>{row.auctionDate}</Typography>
                </Box>
            ),
        },
        {
            field: 'group',
            headerName: 'Grouped',
            width: 80,
            editable: false,
            sortable: false,
            renderCell: ({ row }) => (
                <Typography sx={{ fontWeight: '300' }}>{row.group}</Typography>
            ),
        },
        {
            field: 'result',
            headerName: 'Result',
            width: 100,
            editable: false,
            sortable: false,
            renderCell: ({ row }) => (
                <Typography>{row.status}</Typography>
            ),
        },
    ];


    const handlePrint = () => {
        const content = UserPDF(pdfReport, cityName, machineTime);
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.style.position = 'absolute';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        iframe.style.border = 'none';

        // Wait for the logo to load before writing the content
        const logoImg = new Image();
        logoImg.onload = () => {
            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write(content);
            doc.close();
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        };
        logoImg.src = logo; // Ensure logo is fully loaded

        // In case the logo fails to load, you can still proceed with printing the content
    };


    return (
        <>
            {/* <ReactToPrint
                trigger={() => <button>Print</button>}
                content={() => componentRef.current}
            /> */}
            {/* <button onClick={handlePrint}>Print</button> */}
            <Grid container md={12} marginTop={2} justifyContent={'center'}>
                <Grid item xs={11} md={11} p={2} borderRadius={'5px'}>
                    {/* <Button sx={{
                        backgroundColor: Colors.Primary, '&:hover': {
                            backgroundColor: Colors.Primary
                        },
                        color: 'white',
                        width: { xs: '200px', md: '170px' },
                        marginLeft: '2%',
                        height: '50px'
                    }} onClick={handlePrint} >Print Report</Button> */}

                    <Button sx={{
                        backgroundColor: Colors.Primary, '&:hover': {
                            backgroundColor: Colors.Primary
                        },
                        color: 'white',
                        width: { xs: '200px', md: '250px' },
                        marginLeft: '2%',
                        height: '50px'
                    }} onClick={handlePrint} ><AiOutlinePrinter color='white' size={25} style={{ marginRight: '5px' }} /> Print Report</Button>
                    <Box ref={componentRef} sx={{
                        height: { xs: '600px', md: '550px' },
                        width: '100%',
                        padding: '20px'
                    }}>
                        <DataGrid
                            rows={reportData || []}
                            // columns={columns}
                            columns={columns.map((column) => ({
                                ...column,
                                cellClassName: 'custom-cell-class',
                            }))}
                            autoHeight
                            // pageSize={reportData ? reportData.length : 10}
                            // initialState={{
                            //     pagination: {
                            //         paginationModel: {
                            //             pageSize: 20,
                            //         },
                            //     },
                            // }}
                            // pageSizeOptions={[20]}
                            // checkboxSelection
                            disableRowSelectionOnClick
                            slots={{
                                loadingOverlay: LinearProgress,
                                toolbar: CustomToolbar,
                            }}
                            loading={loading}
                            // slots={{ toolbar: GridToolbar }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                },
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default ViewReport